export default __webpack_public_path__ + "static/media/caretDown.835c500d.svg";